export const NON_MAPPED_FIELD_TYPES = ["header", "spacer", "divider", "line", "note"];